import { makeSelectors } from '@utils/css';

const contentTransitionDurationMs = 375;
const content = "_ud7cn9fl1u";
const card = "_ud7ca3c2mr";
makeSelectors({
  content
});

export { card, content, contentTransitionDurationMs };
import "./comp.router.style.linaria.module.css";
//# sourceMappingURL=comp.router.style.js.map
